import React from 'react';

import BgImage from '../../../assets/assetmark/bg-image.png';
import Logo from '../../../assets/assetmark/logo-white.png';

import { SlideTitle } from '../slide-title';
import { SlideSubtitle } from '../slide-subtitle';
import styles from './styles.module.css';

export type CoverSlideTemplateState = {
  title: string;
  subtitle1: string;
  subtitle2: string;
  date: Date;
  riskProfile: string;
};

export type CoverSlideTemplateProps = {
  readonly state: CoverSlideTemplateState;
  readonly setState: (state: CoverSlideTemplateState) => void;
  readonly editable?: boolean;
};

export function CoverSlideTemplate({
  state,
}: CoverSlideTemplateProps): React.ReactNode {
  return (
    <div
      className={styles.slide}
      style={{ backgroundImage: `url(${BgImage})` }}
    >
      <img className={styles.logo} src={Logo} alt="AMK Logo" />
      <div className={styles.title}>
        <SlideTitle
          style={{
            fontSize: '60px',
            fontWeight: 'bold',
            color: 'white',
          }}
        >
          {state.title}
        </SlideTitle>
      </div>
      <div className={styles.subtitleContainer}>
        <div className={styles.subtitle1}>
          <SlideSubtitle
            style={{
              fontSize: '30px',
              fontWeight: '500',
              color: '#04ACD7',
            }}
          >
            {state.subtitle1}
          </SlideSubtitle>
        </div>
      </div>
      <div className={styles.subtitle2}>
        <SlideSubtitle
          style={{
            fontSize: '30px',
            fontWeight: '400',
            color: '#04ACD7',
          }}
        >
          {state.subtitle2}
        </SlideSubtitle>
      </div>
      <div className={styles.riskProfile}>Risk Profile {state.riskProfile}</div>
      <div className={styles.date}>{state.date.toLocaleDateString()}</div>
    </div>
  );
}
